import { useQuery, useQueryClient } from "@tanstack/react-query";

import type {
    ICampaignCompetitor,
    IRawCompetitor,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";
import { DefaultFetchService } from "app/services/fetchService";

const generateCompetitorsQueryKey = (
    domain: string,
    brands: string[],
    topics: string[],
    country: number,
    cultureName: string,
) => ["llm-tracker", "generate competitors", domain, brands ?? [], topics ?? [], country, cultureName];

export const useGeneratedCompetitors = (
    domain: string,
    brands: string[],
    topics: string[],
    country: number,
    cultureName: string,
    options?: { enabled?: boolean },
) => {
    const queryClient = useQueryClient();
    const queryKey = generateCompetitorsQueryKey(domain, brands, topics, country, cultureName);
    const query = useQuery<IRawCompetitor[]>({
        queryKey,
        queryFn: async ({ signal }) => {
            const fetchService = DefaultFetchService.getInstance();
            const response: ICampaignCompetitor[] = await fetchService.post(
                "/api/aiTracker/competitors/generate",
                {
                    domain,
                    topics,
                    brands,
                    country,
                    cultureName,
                },
                { cancellation: signal },
            );

            return response.map(({ domain: resDomain, ...rest }) => ({
                ...rest,
                domain: {
                    id: resDomain.url,
                    url: resDomain.url,
                    name: resDomain.url,
                    icon: resDomain.favicon,
                    image: resDomain.favicon,
                    searchType: "domain",
                },
            }));
        },
        ...options,
    });

    const cancelQuery = () => queryClient.cancelQueries({ queryKey });

    return { ...query, cancelQuery };
};
